import { fg } from '@atlaskit/platform-feature-flags';
import { withAIOpsDomainPrefix } from '@atlassian/aiops-common';
import { URLBuilder } from '@atlassian/eoc-alert-common';
import { fetch } from '@atlassian/eoc-fetch';

import { type AlertGroupFeatureStateResponse } from '../types';

export const getGroupFeatureStatus = () => {
	const featureName = fg('eoc_fix_error_reporting') ? 'alert-grouping-web' : 'alert-grouping';
	const url = new URLBuilder(withAIOpsDomainPrefix('/v1/aiops/feature-state'))
		.withQueryParam('featureName', featureName)
		.build();
	return fetch<AlertGroupFeatureStateResponse>(url, {
		exactUrl: true,
	});
};
